var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css, styled } from 'styled-components';
import { pxToRem } from "../../utils";
export default styled.span.withConfig({
  displayName: "styled",
  componentId: "1_5_0__sc-vqqnba-0"
})(["", "{display:block;position:relative;", "}"], function (_ref) {
  var theme = _ref.theme;
  return theme.cssPrefix;
}, function (_ref2) {
  var $showCurrencySymbol = _ref2.$showCurrencySymbol;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      ", "\n    "])), $showCurrencySymbol && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        & input {\n          padding-left: ", "rem;\n        }\n      "])), pxToRem(30)));
});
export var StyledCurrencyFieldSymbol = styled.span.withConfig({
  displayName: "styled__StyledCurrencyFieldSymbol",
  componentId: "1_5_0__sc-vqqnba-1"
})(["", "{align-items:center;bottom:0;display:flex;left:", ";position:absolute;top:0;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.cssPrefix;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.vars.spacing_04;
});